import { render, staticRenderFns } from "./InstallButton.vue?vue&type=template&id=104c4a0f&scoped=true&"
import script from "./InstallButton.vue?vue&type=script&lang=js&"
export * from "./InstallButton.vue?vue&type=script&lang=js&"
import style0 from "./InstallButton.vue?vue&type=style&index=0&id=104c4a0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104c4a0f",
  null
  
)

export default component.exports